import {Injectable} from '@angular/core';
import {RequesterService} from './requester.service';
import {ProgressModel} from './models/progress.model';
import {EventsService} from './events.service';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ProgressService {

    public progress: ProgressModel = null;
    public progressPromise: Promise<any> = null;

    constructor(
        private event: EventsService,
        private requesterService: RequesterService,
    ) {
        this.event.subscribe('login', () => {
            this.progress = null;
        });
    }

    // @ts-ignore
    getMyNotifications(): Promise<ProgressModel> {

        if (environment.theme === 'veeam') {
            this.progressPromise = Promise.resolve({result: new ProgressModel()});
        } else {
            this.progressPromise = this.requesterService.get('getMyNotifications');
        }

        return this.progressPromise
            .then(data => {
                this.progress = data.result;
                this.event.publish('progress:getMyNotifications', this.progress);
                return data.result;
            })
            .catch(e => {
                console.log('Error getMyNotifications >> ', e);
                return null;
            });
    }
}
